export const setWindows = (windows, projectId) => {
    return localStorage.setItem(projectId, JSON.stringify(windows));
}

export const getWindows = (projectId) => {
    return JSON.parse(localStorage.getItem(projectId)) || [];
}

export const setDisclaimers = (disclaimers) => {
    localStorage.setItem("sw-editor-disclaimers", JSON.stringify(disclaimers));
}

export const getDisclaimers = () => {
    return JSON.parse(localStorage.getItem(`sw-editor-disclaimers`)) || [];
}